<div class="row">
    <div *ngFor="let category of categories" class="col-6 cat-div" style="background-image: url('../../../../assets/images/{{ category.image }}');">
        <div class="text-wrapper ml-4 col-md-6 col-sm-10 col-xs-10">
            <div class="p-4">
                <h4>{{category.title}}</h4>
                <p>{{category.writeUp}}</p>
            </div>
        </div>
        </div>
        <!-- <div class="col-6 cat-div" style="background-image: url('../../../../assets/images/budding-h3PWUqxpP_0-unsplash.jpg');">
        </div>
</div>
<div class="row">
    <div class="col-6 cat-div" style="background-image: url('../../../../assets/images/elsa-olofsson-Et2GCPYzze4-unsplash.jpg')">
        </div>
        <div class="col-6 cat-div" style="background-image: url('../../../../assets/images/wesley-gibbs-NxRx7_mPdEk-unsplash.jpg')">
        </div> -->
</div>
